import {
  RECEIPT_SCAN_JPEG_QUALITY,
  RECEIPT_SCAN_MAX_PX,
} from '@splitfiesta/shared';

import {
  convertHeicToJpeg,
  encodeJpegLongSide,
  isHeicFile,
} from '@/utils/imageOptimization';

/**
 * The receipt as the scan expects it: a JPEG no larger than 2048 px on its
 * long side. The draft presign accepts JPEG only and signs the byte count,
 * so the blob returned here is exactly what gets uploaded.
 */
export async function toScanJpeg(
  file: File
): Promise<{ blob: Blob; width: number; height: number }> {
  // Browsers other than Safari cannot decode HEIC onto a canvas.
  const decodable = isHeicFile(file) ? await convertHeicToJpeg(file) : file;
  return encodeJpegLongSide(
    decodable,
    RECEIPT_SCAN_MAX_PX,
    RECEIPT_SCAN_JPEG_QUALITY
  );
}
